module.exports = __webpack_public_path__ + "media/faqSection/up-485b6ac9.png";